<template>
	<div class="Login">
		<Header1></Header1>
		<el-dialog title="用户须知" :visible.sync="dialogVisible" width="50%">
			<span style="font-size: 17px;">《基层与地方治理综合管理平台-地方志数据库》用户须知</span>
			<span>
				<p>1.重要提示</p>
				<p>
					感谢您使用由华中师范大学中国农村研究院提供的《基层与地方治理综合管理平台-基层文件数据库》，在使用该系统提供的数据、内容、软件和服务（以下统称为“基层文件系统”）之前，
					请您首先认真阅读本协议，特别是涉及系统使用规则，免除或限制责任的免责条款，对您的权利进行限制的条款，约定法律适用及争议解决方式的条款，并同意遵守本协议。
				</p>
				<p>
					1.2华中师范大学中国农村研究院保留随时修订本协议的权利。本协议或一旦发生变动，华中师范大学中国农村研究院将会在相关网页、服务页面上公布重新修订后的本协议。
					您理解并同意如果您在本协议的变更生效后继续使用，即表明您对修订后的本协议的接受。如果您不能接受修订，您可以通过停止使用来终止本协议。
				</p>
				<p>
					2.帐号维护
				</p>
				<p>
					2.1 您应当对以您的用户帐号进行的所有活动和事件负全部法律责任。您需妥善保管自己的帐号和密码及资料，
					如果您未能保管好自己的帐号和密码及其他资料而遭受任何损失或对华中师范大学中国农村研究院、其他用户或任何第三方造成损害的，您应独自承担全部责任。
				</p>
				<p>
					2.2 上述用户帐号和密码的使用权仅属于初始申请人，禁止赠与、借用、租用、转让或售卖。
					如果华中师范大学中国农村研究院发现使用者并非帐号本人，则有权在未经通知的情况下暂停该帐号而无需向该帐号使用人承担法律责任，由此带来的任何损失由用户自行承担。
				</p>
				<p>
					3.帐号的关停
				</p>
				<p>
					如果您连续一年未登录用户帐号，基层文件系统保留暂停或关闭您的用户帐号的权利。您承认并同意，基层文件系统有权以任何理由，包括但不限于长时间未使用，或基层文件系统认为您已经违反本协议或特定服务法律文件，暂停、关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件，并且基层文件系统系统不因此对您或任何第三人承担任何责任。如果您连续一年未登录用户帐号，基层文件系统保留暂停或关闭您的用户帐号的权利。您承认并同意，基层文件系统有权以任何理由，包括但不限于长时间未使用，或基层文件系统认为您已经违反本协议或特定服务法律文件，暂停、关闭或删除您的帐号及您帐号中所有相关信息及文件，及/或禁止继续使用前述文件，并且基层文件系统系统不因此对您或任何第三人承担任何责任。
				</p>
				<p>
					4.隐私保护
				</p>
				<p>
					华中师范大学中国农村研究院将会采取合理的措施保护您的个人信息。我们不会收集和使用您的个人信息和保护您的隐私。
				</p>
				<p>
					5.其他规定
				</p>
				<p>
					您对基层文件系统或本协议的全部或任何部分的意见及建议可通过相关网站或产品进行反馈，或拨打电话027-67865189与系统管理员进行联系。
					华中师范大学中国农村研究院
				</p>
				2019年2月25日版本
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>

		<div class="Index">
			<div class="IndexMoode">
				<div class="IndexMoodeHeadder">用户登录</div>
				<div class="LoginIndex">
					<div>账号：</div>
					<el-input type="text" size="small" v-model="login.name" class="InputClass" placeholder="请输入账号"></el-input>
				</div>
				<div class="LoginIndex">
					<div>密码：</div>
					<el-input type="password" size="small" v-model="login.password" class="InputClass" placeholder="请输入密码"></el-input>
				</div>
				<div @click="retrievePassword" class="retrievePassword" style="color:#2afceb;font-size: 12px;margin: 0 52%;width: 130px">忘记密码？找回密码</div>
				<div class="LoginIndex tanxingbuju" style="margin-top: -10px">
					<Slide></Slide>
				</div>
				<div class="BTN" style="cursor: pointer;" @click="onLogin">登录</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Header1 from '../components/Header1.vue';
	import Slide from '../components/Slide.vue';
	import {
		Checkbox,
		Message
	} from 'element-ui'
	import {
		request
	} from '../API/ApiUrl'
	import $ from 'jquery';
	import {
		setToken
	} from '@/utils/token'

	export default {
		name: "login",
		data() {
			return {
				flag: true,
				selectedOptions2: [], //行业
				messageresult: '',

				pwd_re: '', //重复密码
				imgSrc: "", //图片地址
				loginCode: "", //登录用户输入的验证码
				msg: "Welcome to Your Vue.js App",
				show: true,
				isVip: 2,
				dialogVisible: false, //false不现实true显示

				login: {
					name: '',
					password: '',
					code: '',
					loginCodeTip: '获取验证码',
					loginCodeLock: false
				},

				sendAuthCode: true,
				auth_time: 60,
				count: '',
				preUrl: ''
			};
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.preUrl = from;
				// //console.log(from) // 上一页面的路由信息
			})
		},
		created() {
			// this.register.education = this.educationList[0].id;
		},
		components: {
			Slide,
			Header1,
			ElCheckbox: Checkbox,
		},
		mounted() {
			this.addVisit();
		},
		methods: {
			//增加点击量
			addVisit() {
				request('/apiVisit/addVisitData', {
					module: 101
				}).then(res => {

				})
			},
			//点击跳转找回密码页面
			retrievePassword() {
				var that = this
				that.$router.push({path:"/RetrievePassword"})
			},
			toRegister() {
				var that = this
				that.$router.push({path:"/register"})
			},

			onLogin() {
				if (this.login.name === '') {
					Message.warning("账号不能为空");
					return;
				}
				if (this.login.password === '') {
					Message.warning("密码不能为空");
					return;
				}
				request('/api/login', {
					username: this.login.name,
					password: this.login.password,
					moduleid:1
				}).then(res => {
					if (res.code === 200) {
						if (res.msg = "登录成功") {
							// //console.log(res)
							Message.success('登录成功');
							// //console.log(JSON.stringify(res.data));
							sessionStorage.setItem("loginData", JSON.stringify(res.data.userInfo));
							const that = this
							setToken(res.token).then(() => {
								const {
									query
								} = this.$route
								let redirect = '/index'
								redirect = (query && query.redirect) || redirect
								console.log('160', redirect)
								that.$router.push({
									path: redirect
								})
							})

						}
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						})
					}
				})
			},

		},

		mounted() {
			if (sessionStorage.getItem("loginData")) {
				let sessions = JSON.parse(sessionStorage.getItem("loginData"));
				this.edit = sessions;
			}


		}
	};
</script>

<style scoped>
	.retrievePassword:hover {
		cursor: pointer;
	}

	.Login {
		width: 100%;
		height: 100%;
		background-image: url("../assets/Img/bgimage.jpg");
	}

	.Index {
		width: 81%;
		margin: 0 auto;
		padding-bottom: 50px;
	}

	/*.RegisterContanier {*/
	/*width: 81%;*/
	/*margin: 0 auto;*/
	/*}*/

	/*.DiFangZhiHeader {*/
	/*padding: 30px 0;*/
	/*width: 173px;*/
	/*text-align: center;*/
	/*font-size: 15px;*/
	/*padding-bottom: 23px;*/
	/*}*/

	.IndexMoode {
		width: 50%;
		background: #2371c785;
		padding-bottom: 50px;
		margin-left: 23%;
		border-radius: 10px;
		margin-top: 6%;
	}

	.RegisterContent {
		width: 34%;
		background: #ffffff;
		margin-left: 33%;
		border-radius: 10px;
		margin-top: 2%;
		padding-bottom: 30px;
	}

	.IndexMoodeRegister {
		width: 40%;
		background: #e8edef33;
		padding-bottom: 50px;
		color: #12f4ce;
		padding: 25px;
	}

	.IndexMoodeHeadder {
		padding: 30px 0 15px 0;
		font-size: 25px;
		text-align: center;
		color: #f2f0f0;
	}

	.LoginIndex {
		font-size: 13px;
		width: 250px;
		margin: 0 auto;
		color: #f2f0f0;
	}

	/**
	 * 注册部分
	 */
	.RegisterItem {
		font-size: 13px;
		width: 520px;
		margin: 5px auto;
		color: #f2f0f0;
	}

	.RegisterItemCode {
		font-size: 13px;
		width: 520px;
		margin: 5px auto;
	}

	.RegisterItemCode span {
		margin-left: 5px;
	}

	.RegisterLabel {
		color: #077882;
		width: 27%;
		display: inline-block;
		text-align: right;
	}

	.RegisterInput {
		width: 60%;
		border: 1px solid #dcd9d9;
		border-radius: 2px;
		height: 25px;
		padding-left: 10px;
	}

	.RegisterItemCode .getVerificationCode:hover {
		cursor: pointer;
		color: #3385ff;
	}

	.RegisterInputCode {
		width: 30%;
		border: 1px solid #dcd9d9;
		border-radius: 2px;
		height: 25px;
		padding-left: 10px;
	}

	/*.RegisterCheck{*/
	/*height: 23px;*/
	/*display: inline-block;*/
	/*}*/
	.divwrap {
		width: 70%;
		display: inline-block;
	}

	/*.divwrap>>>.distpicker-address-wrapper{*/
	/*color: #999;*/
	/*}*/
	.divwrap>>>.distpicker-address-wrapper select {
		width: 100px;
		height: 28px;
		font-size: 12px;
		color: #938888;
	}

	/*.divwrap>>>.address-header{*/
	/*!*position: fixed;*!*/
	/*!*bottom: 400px;*!*/
	/*width: 100%;*/
	/*background: #000;*/
	/*color:#fff;*/
	/*}*/
	/*.divwrap>>>.address-header ul li{*/
	/*flex-grow: 1;*/
	/*text-align: center;*/
	/*}*/
	/*.divwrap>>>.address-header .active{*/
	/*color: #fff;*/
	/*border-bottom:#666 solid 8px*/
	/*}*/
	/*.divwrap>>>.address-container .active{*/
	/*color: #000;*/
	/*}*/


	.RegisterInput::-webkit-input-placeholder {
		/* placeholder颜色  */
		color: #aab2bd;
		/* placeholder字体大小  */
		font-size: 12px;
		/* placeholder位置  */
		text-align: left;
	}

	.RegisterContentHeadder {
		padding: 13px 0 15px 0;
		font-size: 25px;
		text-align: center;
		color: #f2f0f0;
		background-color: #2371c7;
		border-radius: 10px 10px 0 0;
	}

	::-webkit-input-placeholder {
		font-size: 13px;
	}

	.LoginIndex>div {
		text-align: left;
	}

	/*.formlabel{*/
	/*color: #FFFFFF;*/
	/*}*/

	.InputClass {
		margin: 5px 0 13px;
	}

	/*.InputYanZhen {*/
	/*width: 125px;*/
	/*height: 30px;*/
	/*background: rgba(255, 255, 255, 1);*/
	/*border: 1px solid rgba(215, 215, 215, 1);*/
	/*box-sizing: border-box;*/
	/*padding-left: 8px;*/
	/*}*/

	/*.Yanzhen {*/
	/*display: flex;*/
	/*width: 250px;*/
	/*justify-content: space-between;*/
	/*margin: 5px 0 10px;*/
	/*}*/



	.Yanzhen>div {
		width: 100px;
		text-align: center;
		font-size: 13px;
		box-sizing: border-box;
		line-height: 30px;
		color: #fff;
		height: 30px;

		cursor: pointer;
	}

	.borderr {
		display: flex;
		width: 250px;
		margin: 0 auto;
		font-size: 13px;
	}

	.borderr>div:nth-child(1) inputs {
		width: 12px;
		height: 12px;
		background: #fff;
		border: none;
		margin-top: 3px;
		margin-right: 3px;
		cursor: pointer;
	}

	.checkboxRead {
		margin-right: 4px;
		margin-top: 1px;
	}

	.SpanColor {
		color: rgb(0, 122, 204);
	}

	.RegisterBtn {
		height: 40px;
		width: 180px;
		margin: 11px auto;
		background: #2371c7;
		color: #f1f1f2;
		font-size: 15px;
		line-height: 40px;
		text-align: center;
		border-radius: 4px;
	}

	.RegisterBtn:hover {
		background: #408ce1;
		color: #f1f1f2;
	}

	.BTN {
		height: 40px;
		width: 180px;
		margin: 0 auto;
		background: #ffffffed;
		color: #2471c7;
		font-size: 15px;
		line-height: 40px;
		margin-top: 50px;
		text-align: center;
		font-size: 18px;
		border-radius: 4px;
	}

	.BTN:hover {
		height: 40px;
		width: 180px;
		margin: 0 auto;
		background: #ffffffed;
		color: #1cc2da;
		font-size: 15px;
		line-height: 40px;
		margin-top: 50px;
		text-align: center;
		font-size: 18px;
		border-radius: 4px;
	}

	.yanzhengma {
		height: 30px;
		background: #FFFFFF;
	}
</style>
